"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1583))
 * @lastsynced 2026-10-29T13:51:23.442Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const EyeOpen = createSVGIcon(
  <path
    d="M22.687 10.858a1.656 1.656 0 0 1 0 2.284C20.88 15.086 16.776 18.857 12 18.857s-8.88-3.771-10.687-5.715a1.656 1.656 0 0 1 0-2.284C3.12 8.914 7.224 5.143 12 5.143s8.88 3.771 10.687 5.715ZM8.57 12a3.428 3.428 0 1 0 6.857 0 3.428 3.428 0 0 0-6.857 0Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "EyeOpen",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
